import { render, staticRenderFns } from "./TaxReturnPage.vue?vue&type=template&id=07a09864&scoped=true"
import script from "./TaxReturnPage.vue?vue&type=script&lang=js"
export * from "./TaxReturnPage.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnPage.vue?vue&type=style&index=0&id=07a09864&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a09864",
  null
  
)

export default component.exports